import React, { useEffect, useState } from "react";
import Text from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import axios from "api/configApi";
import CircularProgress from "@material-ui/core/CircularProgress";
import { formatVolunteerTime } from "common/utils";

interface StatisticsTabProps {
  /** When set (e.g. Manage Volunteers Work), loads statistics for that user. */
  userId?: string;
}

const StatisticsTab = React.memo((props: StatisticsTabProps) => {
  const { userId } = props;
  const classes = styles();
  const translate = useTranslation().t;
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchStatistics = async () => {
      try {
        setLoading(true);
        const res = await axios.get("/my-works/statistics", {
          params: userId ? { userId } : {},
        });
        setData(res.data || []);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to load statistics", error);
        setData({});
      } finally {
        setLoading(false);
      }
    };
    fetchStatistics();
  }, [userId]);

  const renderStatistics = () => {
    if (loading) {
      return (
        <div style={{ textAlign: "center", padding: 16 }}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <>
        <Text className={classes.textContent}>
          {translate("NUMBER_OF_SERVICES_VALIDATED")}: {data?.totalServicesValidated || 0}
        </Text>
        <Text className={classes.textContent}>
          {translate("NUMBER_OF_APPROVED_SERVICES_VALIDATED")}: {data?.totalServicesValidatedApproved || 0}
        </Text>
        <Text className={classes.textContent}>
          {translate("NUMBER_OF_SERVICES_ADDED")}: {data?.totalServicesAdded || 0}
        </Text>
        <Text className={classes.textContent}>
          {translate("NUMBER_OF_BADGES_EARNED")}: {data?.totalBadgesAdded || 0}
        </Text>
        <Text className={classes.textContent}>
          {translate("TIME_VOLUNTEERED")}:{" "}
          {formatVolunteerTime(data?.totalMinutesSpent || 0, translate)}
        </Text>
        <Text className={classes.textContent}>
          {translate("MY_CURRENT_RANK")}: {data?.currentRank ? data?.currentRank : "-"}
        </Text>
        <Text className={classes.textContent}>
          {translate("POINTS_EARNED")}: {data?.totalMinutesSpent ?? "0"}
        </Text>
        <Text className={classes.textContent}>
          {translate("CURRENT_BADGE")}:{" "}
          {data.badgeHistory && data.badgeHistory.length > 0
            ? data.badgeHistory[data.badgeHistory.length - 1].name
            : "-"}
        </Text>
      </>
    );
  };

  return (
    <>
      <Container className={classes.root}>{renderStatistics()}</Container>
    </>
  );
});

export default StatisticsTab;
